<template>
	<div>
		<div class="d-flex justify-content-center py-4" v-if="isLoading">
			<loader/>
		</div>
		<notification-message
			message="Parece que aún no agregas categorías"
			v-if="categories=='' && !isLoading"
		/>
		<div class="main-content-container container-fluid px-4">

      <div class="page-header row no-gutters py-4" v-if="!isLoading">
        <div class="col-12 col-sm-6 text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">Visión general</span>
          <h3 class="page-title">Categorías</h3>
        </div>
        <div class="col-12 col-sm-6 d-flex align-items-center">
          <div class="d-none d-md-inline-flex mb-sm-0 mx-auto ml-sm-auto mr-sm-0" role="group" aria-label="Page actions">
            <router-link to="agregar/categoria" id="add-new-event" class="btn btn-primary">
              <i class="fas fa-plus"></i> 
              Categoría 
            </router-link>
          </div>
        </div>
      </div>

			<div class="row">
				<div class="col-lg-3 col-md-6 col-sm-12 mb-4" v-for="(item, index) of categories">
						<div class="card card-small card-post card-post--1">
							<div class="card-body text-center">
								<h4 class="font-weight-bold text-uppercase">{{ item.name }}</h4>
							</div>
							<div class="card-footer border-top text-primary">
								<span class="badge badge-secondary mr-2">
									<i class="fas fa-trash" @click.prevent="deleteOption(item.id, index)"/>
								</span>
								<router-link :to="'categoria/' + item.slug" class="badge badge-secondary"><i class="fas fa-edit"></i></router-link>
							</div>
						</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import NotificationMessage from '@/components/general/NotificationMessage.vue';
	export default {
		components: {
			NotificationMessage
		},

		data() {
			return {
				isLoading: true,
				categories: []
			}
		},

		mounted() {
			this.getCategories();
		},

		methods: {
			async getCategories() {
				const url = `${process.env.VUE_APP_ROOT_API}/category`;
				const response = await fetch(url);
				if(response.status == 200) {
					this.isLoading = false;
					this.categories = await response.json();
				}
			},

			deleteOption(id, index) {
				const message = '¿Quieres eliminar esta categoría?';
				const options = {
					okText: 'Sí',
					cancelText: 'No'
				};
				let that = this;
				this.$dialog
					.confirm(message, options)
					.then(function(dialog) {
						that.deleteCategory(id, index);
					});
			},

			async deleteCategory(id, index) {
				const url = `${process.env.VUE_APP_ROOT_API}/category/${id}`;
				const settings = {
					method: 'DELETE'
				};
				const response = await fetch(url, settings);
				switch (response.status) {
					case 200:
						this.categories.splice(index, 1);
						break;
				}
			}
		}
	}
</script>